import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 mt-24 bg-white dark:bg-[#111A28]" data-testid="site-footer">
      <div className="max-w-screen-2xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center mb-3">
            <img src="/logo-3dzona.png" alt="3dzona.lt" className="h-10 w-auto dark:hidden" /><img src="/logo-3dzona-dark.png" alt="3dzona.lt" className="h-10 w-auto hidden dark:block" />
          </div>
          <p className="text-gray-600 dark:text-gray-300 text-sm mt-4 leading-relaxed">Lietuviška 3D spausdinimo parduotuvė. Bambu Lab, PLA, PETG, ABS, ASA, TPU ir specialios atmainos.</p>
        </div>
        <div>
          <div className="label-mono">Parduotuvė</div>
          <ul className="space-y-2 mt-3 text-sm text-gray-700 dark:text-gray-300">
            <li><Link to="/parduotuve" className="hover:text-[#00B5E2]">Visi produktai</Link></li>
            <li><Link to="/parduotuve?category=bambu-lab" className="hover:text-[#00B5E2]">Bambu Lab</Link></li>
            <li><Link to="/parduotuve?category=pla" className="hover:text-[#00B5E2]">PLA / PETG</Link></li>
            <li><Link to="/info" className="hover:text-[#00B5E2]">Naudinga info</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono">Pagalba</div>
          <ul className="space-y-2 mt-3 text-sm text-gray-700 dark:text-gray-300">
            <li><Link to="/pristatymas" className="hover:text-[#00B5E2]">Pristatymas ir grąžinimas</Link></li>
            <li><Link to="/atsisakyti-sutarties" className="hover:text-[#00B5E2]">Atsisakyti sutarties</Link></li>
            <li><Link to="/duk" className="hover:text-[#00B5E2]">D.U.K.</Link></li>
            <li><Link to="/mus" className="hover:text-[#00B5E2]">Apie mus</Link></li>
            <li><Link to="/taisykles" className="hover:text-[#00B5E2]">Pirkimo taisyklės</Link></li>
            <li><Link to="/privatumas" className="hover:text-[#00B5E2]">Privatumo politika</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-mono">Kontaktai</div>
          <ul className="space-y-2 mt-3 text-sm text-gray-700 dark:text-gray-300">
            <li><a href="mailto:info@3dzona.lt" className="hover:text-[#00B5E2]">info@3dzona.lt</a></li>
            <li><a href="tel:+37062894862" className="hover:text-[#00B5E2]">+370 628 94862</a></li>
          </ul>
          <div className="label-mono mt-6">Rekvizitai</div>
          <ul className="space-y-1 mt-3 text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
            <li>MB „Trizona“</li>
            <li>Įmonės kodas: 308056363</li>
            <li>PVM mokėtojo kodas: LT100020490013</li>
            <li>V. Nagevičiaus g. 3, Vilnius</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-200 dark:border-gray-700">
        <div className="max-w-screen-2xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500 dark:text-gray-400 font-mono">
          <div>© 2026 3dzona.lt · MB „Trizona“ · į.k. 308056363 · PVM k. LT100020490013</div>
          <div>BUILT FOR MAKERS · LT/EU</div>
        </div>
      </div>
    </footer>
  );
}
